module.exports = __webpack_public_path__ + "static/media/czechRepublic.889c34a2.png";